import React, { Fragment } from 'react'
import * as Logger from 'loglevel'

import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap'

import { DataTableConstant } from '../../../index'

class HubNodeSelector extends React.Component {
  // this.props.nodes: [{id: any, name: string}]
  constructor(props) {
    Logger.debug(`Constructing NodeSelector`)
    super(props)
    this.state = {
      activeNodeId: props.nodeId
      //            nodes: props.nodes
    }
  }

  async componentDidMount() {
    // This method is called when the component is first added to the document
    // Logger.debug(`NodeSelector componentDidMount`)
    // if (!this.props.nodes) {
    //   Logger.debug(`NodeSelector componentDidMount: requesting nodes`)
    //   await this.props.requestNodes()
    //   Logger.debug(`NodeSelector nodes requested.`)
    // }

    var initialNode = this.props.nodes.find(
      (f) => f.name === this.props.initialNode
    )

    if (this.props.initialNode && !!initialNode) {
      this.setState({
        activeNodeId: initialNode.id
      })
    }
  }

  componentDidUpdate() {
    Logger.debug(`NodeSelector componentDidUpdate`)
  }

  onHubNodeSelected = (node) => {
    Logger.debug(`NodeSelector: onHubNodeSelected(${node})`)
    if (node.id < 0) {
      node.id = this.props.nodes[0].id
    }
    this.props.onHubNodeSelected(node)
    Logger.debug('onHubNodeSelected: ' + node)
    const state = {
      ...this.state,
      activeNodeId: node.id
    }
    this.setState(state)
  }

  getActiveNode = () => {
    const index = (
      typeof this.state.activeNodeId === 'number'
        ? this.state.activeNodeId >= 0
        : !!this.state.activeNodeId
    )
      ? this.props.nodes.findIndex((f) => f.id === this.state.activeNodeId)
      : 0

    if (index < 0) {
      return null
    }
    return this.props.nodes[index]
  }

  renderDropdown(canModify, node, dropItems) {
    Logger.debug(node)
    Logger.debug(dropItems)
    Logger.debug(this.props.nodes)
    return (
      <Dropdown className='formDropdown nodeDropdown'>
        <Dropdown.Toggle
          id='dropdown-basic'
          disabled={canModify !== undefined && !canModify}
        >
          {node.name}
        </Dropdown.Toggle>
        <Dropdown.Menu>{dropItems}</Dropdown.Menu>
      </Dropdown>
    )
  }

  render() {
    Logger.debug(`rendering NodeSelector, props=`, this.props)
    if (this.props.action === DataTableConstant.HUB_ACTION_STATE.LOADING) {
      return <div>Loading Nodes...</div>
    }
    if (this.props.error) {
      return <div>Loading Nodes failed, error={this.props.error}</div>
    }
    if (this.props.nodes == null) {
      Logger.debug(`Rendering "No Nodes"`)
      return <div> No Hub Node loaded </div>
    }

    const node = this.getActiveNode()
    const dropItems = this.props.nodes.map((n) => {
      return (
        <Dropdown.Item
          key={n.id}
          active={n.id === node.id}
          onClick={() => this.onHubNodeSelected(n)}
        >
          {n.name}
        </Dropdown.Item>
      )
    })
    return (
      <Fragment>
        <div className='formTitle'>Production Centre</div>
        {this.props.canModify !== undefined && !this.props.canModify ? (
          <OverlayTrigger
            key='cantModify'
            placement='bottom'
            overlay={
              <Tooltip className='dropdownTooltip rowActionTooltip'>
                You Have No
                <br />
                Permission to Modify
                <br />
                Production Centre
              </Tooltip>
            }
          >
            {this.renderDropdown(this.props.canModify, node, dropItems)}
          </OverlayTrigger>
        ) : (
          this.renderDropdown(this.props.canModify, node, dropItems)
        )}
      </Fragment>
    )
  }
}

export default HubNodeSelector
